"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPromoTokensResponseAllOfToJSON = exports.GetPromoTokensResponseAllOfFromJSONTyped = exports.GetPromoTokensResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetPromoTokensResponseAllOfFromJSON(json) {
    return GetPromoTokensResponseAllOfFromJSONTyped(json, false);
}
exports.GetPromoTokensResponseAllOfFromJSON = GetPromoTokensResponseAllOfFromJSON;
function GetPromoTokensResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'promoTokens': (json['promoTokens'].map(_1.PromoTokenFromJSON)),
    };
}
exports.GetPromoTokensResponseAllOfFromJSONTyped = GetPromoTokensResponseAllOfFromJSONTyped;
function GetPromoTokensResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'promoTokens': (value.promoTokens.map(_1.PromoTokenToJSON)),
    };
}
exports.GetPromoTokensResponseAllOfToJSON = GetPromoTokensResponseAllOfToJSON;
